import { useState } from "react"
import { useEffectOnce } from "react-use"

// false during SSR and the hydration render, true once mounted on the client
export const useHasMounted = () => {
  const [hasMounted, setHasMounted] = useState(false)

  useEffectOnce(function markAsMounted() {
    setHasMounted(true)
  })

  return hasMounted
}
